import { useContext } from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { toJS } from "mobx";

import CommonStore from './commonStore/CommonStore';
import BoardStore from './boardStore/BoardStore';
import QnaBoardStore from './qnaBoardStore/QnaBoardStore';
import CompanyStore from './companyStore/CompanyStore';
import UserInfoStore from './userInfoStore/UserInfoStore';
import CenterInfoStore from './centerInfoStore/CenterInfoStore';
import GoodsInfoStore from './goodsInfoStore/GoodsInfoStore';
import GoodsJobStore from './goodsJobStore/GoodsJobStore';
import GoodsGroupStore from './goodsGroupStore/GoodsGroupStore';
import OrderStore from './orderStore/OrderStore';
import TransStore from './transStore/TransStore';
import SettleStore from './settleStore/SettleStore';
import OrderReturnStore from './orderReturnStore/OrderReturnStore';
import StatsStore from './statsStore/StatsStore';

const RootStore = {
  commonStore : new CommonStore(),            // 공통
  boardStore : new BoardStore(),              // 공지사항
  qnaBoardStore : new QnaBoardStore(),        // Q&A게시판
  companyStore : new CompanyStore(),          // 회사정보
  
  userInfoStore : new UserInfoStore(),        // 사원정보관리 & 직무정보관리
  centerInfoStore : new CenterInfoStore(),    // 회사정보관리
  
  goodsInfoStore : new GoodsInfoStore(),      // 상품관리
  goodsJobStore : new GoodsJobStore(),        // 상품이용정보관리
  goodsGroupStore : new GoodsGroupStore(),    // 상품군관리

  orderStore : new OrderStore(),              // 주문
  transStore : new TransStore(),              // 주문이력
  settleStore : new SettleStore(),            // 정산관리
  orderReturnStore : new OrderReturnStore(),  // 반품

  statsStore : new StatsStore(),  // 통계
}

function useStores() {
  return useContext(MobXProviderContext);
}

export { RootStore };

export default useStores;
export { observer, toJS };